import React, { useEffect, useState } from 'react';
import { Dropdown, Menu, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import useLanguageStore from '../../stores/languageStore';
import ReactCountryFlag from 'react-country-flag';

// Map of language codes to country codes for flags
const COUNTRY_FLAGS = {
  en: 'US', // English - United States
  it: 'IT', // Italian - Italy
  de: 'DE', // German - Germany
  fr: 'FR', // French - France
  ja: 'JP', // Japanese - Japan
  ko: 'KR', // Korean - South Korea
  es: 'ES'  // Spanish - Spain
};

// Map of language codes to their native names (for tooltips)
const LANGUAGE_LABELS = {
  en: 'English',
  it: 'Italiano',
  de: 'Deutsch',
  fr: 'Français',
  ja: '日本語',
  ko: '한국어',
  es: 'Español'
};

const LanguageSelector = ({ style = {} }) => {
  const { i18n } = useTranslation();
  const { language, setLanguage } = useLanguageStore();
  const [currentLangCode, setCurrentLangCode] = useState(language || 'en');
  
  // Effect to synchronize component with language store
  useEffect(() => {
    if (language && language !== currentLangCode) {
      setCurrentLangCode(language);
    }
  }, [language, currentLangCode]);
  
  // Effect to ensure i18n instance is synchronized with language store
  useEffect(() => {
    if (language && language !== i18n.language) {
      i18n.changeLanguage(language);
    }
  }, [language, i18n]);
  
  const handleLanguageChange = (e) => {
    const newLang = e.key;
    // This updates the language in Zustand store and persists to localStorage
    setLanguage(newLang);
  };

  // Single flag render without any box
  const renderFlag = (langCode) => {
    // Ensure we have a valid country code
    const countryCode = COUNTRY_FLAGS[langCode] || 'US';
    
    return (
      <div style={{ padding: '2px', borderRadius: '4px' }}>
        <ReactCountryFlag 
          countryCode={countryCode} 
          svg 
          style={{ 
            width: '32px', 
            height: '20px',
            borderRadius: '6px',
            overflow: 'hidden'
          }} 
        />
      </div>
    );
  };
  
  // Menu for language options
  const menu = (
    <Menu 
      onClick={handleLanguageChange} 
      selectedKeys={[currentLangCode]}
      style={{ minWidth: '70px' }} 
    >
      {Object.keys(COUNTRY_FLAGS).map(lang => (
        <Menu.Item key={lang} style={{ padding: '8px 14px', textAlign: 'center' }}>
          <Tooltip>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <ReactCountryFlag 
                countryCode={COUNTRY_FLAGS[lang]} 
                svg 
                style={{ 
                  width: '28px', 
                  height: '18px',
                  borderRadius: '5px',
                  overflow: 'hidden'
                }} 
              />
            </div>
          </Tooltip>
        </Menu.Item>
      ))}
    </Menu>
  );
  
  return (
    <Dropdown 
      overlay={menu} 
      trigger={['click']} 
      placement="bottomCenter"
      arrow={true}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      overlayStyle={{ 
        minWidth: '55px',
        marginTop: '10px',
        zIndex: 1010 
      }}
    >
      <Tooltip>
        <div style={{ 
          cursor: 'pointer', 
          display: 'flex', 
          justifyContent: 'center', 
          position: 'relative',
          ...style 
        }}>
          {renderFlag(currentLangCode)}
        </div>
      </Tooltip>
    </Dropdown>
  );
};

export default LanguageSelector;